export default __webpack_public_path__ + "img/e84f3f70f6ce041a460afc2db7656f6b.svg";